"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var Ingredients_1 = require("../components/Ingredients/Ingredients");
var targetNode = document.querySelector('.ingredients-section');
if (targetNode) {
    (0, preact_1.render)((0, preact_1.h)(Ingredients_1.default, null), targetNode);
}
